/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

 import $ from 'jquery';
 import {load} from '@shopify/theme-sections';
 import Variants from '@shopify/theme-variants';
 import {formatMoney} from '@shopify/theme-currency';
 import {register} from '@shopify/theme-sections';
 import Swiper, { Navigation, Thumbs, A11y, Keyboard, FreeMode } from 'swiper';

 // // Style includes
 import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

 const selectors = {
     addToCart: '[data-add-to-cart]',
     addToCartText: '[data-add-to-cart-text]',
     comparePrice: '[data-compare-price]',
     comparePriceText: '[data-compare-text]',
     originalSelectorId: '[data-product-select]',
     priceWrapper: '[data-price-wrapper]',
     productImageWrapper: '[data-product-image-wrapper]',
     productFeaturedImage: '[data-product-featured-image]',
     productJson: '[data-product-page]',
     productPrice: '[data-product-price]',
     productThumbnailsSlider: 'carousel--product-thumbnails',
     productFeatureSlider: 'carousel--featured-product',
     productThumbs: '[data-product-single-thumbnail]',
     radioOptionSelector: '[data-radio-option-selector]',
     singleOptionSelector: '[data-single-option-selector]',
     productMediaWrapper: '[data-product-single-media-wrapper]',
     productMediaTypeVideo: '[data-product-media-type-video]',
     productMediaTypeModel: '[data-product-media-type-model]',
     variantOptionLabels: '.swatch__option label',
     colorOptionLabels: '.color-swatches .swatch__option',
     quantity: '#Quantity',
     productSwiperThumbs: null,
     productSwiperFeature: null,
     productSku: '.product-single__sku'
 };

 const cssClasses = {
     activeThumbnail: 'active-thumbnail',
     hide: 'hide',
 };

 const keyboardKeys = {
     ENTER: 13,
 };

 var size_selected = false;
 var productFeatureSwiper;
 var productThumbnailSwiper;

 function toggleInnerFocus(slider) {
     let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
     $(focusableElements).each(function(index, el) {
         $(slider.slides).each(function(index, slide) {
             if (index === slider.activeIndex) {
                 if (el === '.plyr') {
                     $(slide).find(el)
                     .attr('tabindex', "0");
                 } else {
                     $(slide).find(el)
                     .removeAttr('tabindex');
                 }
             } else {
                 $(slide)
                 .find(el)
                 .attr('tabindex', '-1');
             }
         })
     })
 }

 $(document).ready(function(){

    var ProductVideo = (function() {
        var videos = {};

        var hosts = {
          html5: 'html5',
          youtube: 'youtube'
        };

        var attributes = {
          enableVideoLooping: 'enable-video-looping',
          videoId: 'video-id'
        };

        function init(videoContainer, sectionId) {
            console.log("init video");
          if (!videoContainer.length) {
            console.log("no vide");
            return;
          }

          var videoElement = videoContainer.find('iframe, video')[0];
          var mediaId = videoContainer.data('mediaId');

          if (!videoElement) {
            console.log("no video 2");
            return;
          }

          videos[mediaId] = {
            mediaId: mediaId,
            sectionId: sectionId,
            host: hostFromVideoElement(videoElement),
            container: videoContainer,
            element: videoElement,
            ready: function() {
              createPlayer(this);
            }
          };

          var video = videos[mediaId];
          switch (video.host) {
            case hosts.html5:
              setupPlyrVideos();
              break;
            case hosts.youtube:
              setupYouTubeVideos();
              break;
          }
        }

        function setupPlyrVideos() {
          // if (errors) {
          //   fallbackToNativeVideo();
          //   return;
          // }

          loadVideos(hosts.html5);
        }

        function setupYouTubeVideos() {

          window.YT.ready(function() {
              loadVideos(hosts.youtube);
          });
        }

        function createPlayer(video) {
          if (video.player) {
            return;
          }

          var productMediaWrapper = video.container.closest(
            selectors.productMediaWrapper
          );
          var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

          switch (video.host) {
            case hosts.html5:
              // eslint-disable-next-line no-undef
              video.player = new Shopify.Plyr(video.element, {
                loop: { active: enableLooping }
              });

              video.player.on('ready', function() {
                  toggleInnerFocus(selectors.productSwiperFeature);
              })
              break;
            case hosts.youtube:
              var videoId = productMediaWrapper.data(attributes.videoId);

              video.player = new YT.Player(video.element, {
                videoId: videoId,
                events: {
                  onStateChange: function(event) {
                    if (event.data === 0 && enableLooping) event.target.seekTo(0);
                  }
                }
              });
              break;
          }

        $('body, html').on('mediaHidden xrLaunch', productMediaWrapper, function() {
            if (!video.player) return;

            if (video.host === hosts.html5) {
              video.player.pause();
            }

            if (video.host === hosts.youtube && video.player.pauseVideo) {
              video.player.pauseVideo();
            }
        });

        $('body, html').on('mediaVisible', productMediaWrapper, function() {
            if (!video.player) return;

              if (video.host === hosts.html5) {
                  video.player.play();
              }

              if (video.host === hosts.youtube && video.player.playVideo) {
                  video.player.playVideo();
              }
        });
    }

        function hostFromVideoElement(video) {
          if (video.tagName === 'VIDEO') {
            return hosts.html5;
          }

          if (video.tagName === 'IFRAME') {
            if (
              /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                video.src
              )
            ) {
              return hosts.youtube;
            }
          }
          return null;
        }

        function loadVideos(host) {
          for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
              var video = videos[key];
              if (video.host === host) {
                  video.ready();
              }
            }
          }
        }

        function fallbackToNativeVideo() {
          for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
              var video = videos[key];

              if (video.nativeVideo) continue;

              if (video.host === hosts.html5) {
                video.element.setAttribute('controls', 'controls');
                video.nativeVideo = true;
              }
            }
          }
        }

        function removeSectionVideos(sectionId) {
          for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
              var video = videos[key];

              if (video.sectionId === sectionId) {
                if (video.player) video.player.destroy();
                delete videos[key];
              }
            }
          }
        }

        return {
          init: init,
          hosts: hosts,
          loadVideos: loadVideos,
          removeSectionVideos: removeSectionVideos
        };
      })();

     /**
      * Product section constructor. Runs on page load as well as Theme Editor
      * `section:load` events.
      * @param {string} container - selector for the section container DOM element
      */

     register('product-group', {
         onLoad() {
             this.$container = $(this.container);
             this.namespace = `.${this.id}`;
             var self = this;

             // Stop parsing if we don't have the product json script tag when loading
             // section in the Theme Editor
             if (!$(selectors.productJson, this.$container).html()) {
                 return;
             }

             this.productSingleObject = JSON.parse(
                 $(selectors.productJson, this.$container).html(),
             );

             const options = {
                 $container: this.$container,
                 enableHistoryState: this.$container.data('enable-history-state') || false,
                 radioOptionSelector: this.radioOptionSelector,
                 singleOptionSelector: selectors.singleOptionSelector,
                 originalSelectorId: selectors.originalSelectorId,
                 product: this.productSingleObject,
             };

             this.settings = {};
             this.variants = new Variants(options);
             this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

             this.$container.on(
                 `variantChange${this.namespace}`,
                 this.updatePDPInformation.bind(this)
             );
             this.$container.on(
                 `variantPriceChange${this.namespace}`,
                 this.updateProductPrices.bind(this),
             );

             $('.form__increment').on('click', function() {
                 self.$container.trigger({
                     type: 'variantPriceChange',
                     variant: self.variants.currentVariant
                 });
             });

             $(selectors.colorOptionLabels).on('click', function() {
                let $this = $(this);

                if (!$this.hasClass('selected')) {
                    const selectedColorSwatch = $(this).attr('data-swatch');
                    $(selectors.colorOptionLabels+".selected").removeClass('selected');
                    $(this).addClass('selected');
                    self.$container.trigger({
                        type: 'variantChange',
                        variant: self.variants.currentVariant
                    })
                    var productJson = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')).html());
                    var productData = productJson;

                    $(selectors.originalSelectorId).attr('data-product-handle', productData.handle);

                    const productVariantURL = "/products/"+ $(selectors.originalSelectorId).attr('data-product-handle');
                    window.history.replaceState("","", productVariantURL);

                    $(selectors.productJson).html($('#ProductJson-' + $(this).attr('data-product-handle')).html());
                    $('.product__form').attr('data-product-handle', $(this).attr('data-product-handle'));

                    var productOptionsJson = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')+'-options').html());
                    var productOptions = productOptionsJson;
                    var variantInventory = JSON.parse($('#ProductJson-' + $(this).attr('data-product-handle')+'-inventory').html());
                    var media = productData.media;
                    var productVariants = productData.variants;
                    var productImagesSwiperWrapper = '';
                    var productThumbnailsSwiperWrapper = '';

                    $('.btn--add-to-cart--quick').addClass('btn--select-size');
                    $(selectors.addToCartText).text('Add to Cart');
                    $('.product-single__sku.variant-sku').text("");
                    $('.swatch__subtitle').text("");

                    for (let i = 0; i < media.length; i++) {

                        productImagesSwiperWrapper += "<div class='swiper-slide' tabindex='-1' data-index='"+i+"'>";
                        productImagesSwiperWrapper += "<div id='FeaturedMedia-product--group-"+ media[i].id+"-wrapper' class='product-single__media-wrapper js' data-product-media-type-video='' data-product-single-media-wrapper='' data-media-id='product--group-"+media[i].id+"'>";

                        if (media[i].media_type == 'image') {
                            productImagesSwiperWrapper += "<picture>";
                                productImagesSwiperWrapper += "<img class='responsive-image__image background-image' src='"+media[i].src+"' srcset='"+media[i].src+"&amp;width=180 180w,"+media[i].src+"&amp;width=360 360w,"+media[i].src+"&amp;width=540 540w,"+media[i].src+"&amp;width=680 680w,"+media[i].src+"&amp;width=720 720w,"+media[i].src+"&amp;width=900 900w,"+media[i].src+"&amp;width=1080 1080w,' tabindex='-1' alt='"+media[i].alt+"' decoding='async' loading='lazy'>";
                            productImagesSwiperWrapper += "</picture>";
                        } else if (media[i].media_type == 'video') {
                            productImagesSwiperWrapper += '<video playsinline="playsinline" class="media-video" preload="metadata" aria-label="'+productData.title+'" poster="'+media[i].preview_image.src+'">';
                            for(var j = media[i].sources.length-1; j >= 0; j--) {
                                productImagesSwiperWrapper += '<source src="' + media[i].sources[j].url + '" type="' + media[i].sources[j].mime_type  + '">'
                            }
                            productImagesSwiperWrapper +=  '<img src="'+media[i].preview_image.src+'">';
                            productImagesSwiperWrapper += '</video>';
                        }
                        productImagesSwiperWrapper += "</div>";
                        productImagesSwiperWrapper += "</div>";

                        productThumbnailsSwiperWrapper += "<div class='swiper-slide product__thumbnail-item product__thumbnails-item--'"+i+"' tabindex='-1' data-index='"+i+"'>";
                        productThumbnailsSwiperWrapper += "<div class='product-single__thumbnail product-single__thumbnail--"+ self.id +"' data-product-single-thumbnail data-thumbnail-id='" +self.id+"-" + media[i].id +"'>";

                        if (media[i].media_type == 'image') {
                            productThumbnailsSwiperWrapper += "<img class='product-single__thumbnail-image' src='"+media[i].preview_image.src+"?&width=250' alt='"+media[i].alt+"'>";
                        } else if (media[i].media_type == 'video' || media[i].media_type == 'external_video') {
                            productThumbnailsSwiperWrapper += "<img class='product-single__thumbnail-image product-single__thumbnail-image--group' src='"+media[i].preview_image.src+"?&width=250' alt='"+media[i].alt+"'>";
                        }

                        if(media[i].media_type == 'video' || media[i].media_type == 'external_video') {
                            productThumbnailsSwiperWrapper += "<div class='product-single__thumbnail-badge'>";
                            productThumbnailsSwiperWrapper += "<span class='icon svg--baseline'><svg class='icon icon__play'><use xlink:href='#icon-play'></use></svg></span>";
                            productThumbnailsSwiperWrapper += "</div>";
                        }

                        productThumbnailsSwiperWrapper += "</div>";
                        productThumbnailsSwiperWrapper += "</div>";
                    }

                    var productVariantOptions = "";
                    for (let i = 0; i < productVariants.length; i++) {
                        var variantDisabled = (productVariants[i].available == true) ? "" : "disabled='disabled'";
                        productVariantOptions += "<option "+ variantDisabled +" value='"+productVariants[i].id+"' data-option-title='"+productVariants[i].title+"' data-inventory-quantity='"+variantInventory[i].inventory_quantity+"'>"+productVariants[i].title+"</option>";
                        $(selectors.originalSelectorId).html(productVariantOptions);
                    }

                    for (let i = 0; i < productOptions.length; i++) {
                        var optionIndex = i + 1,
                            optionSelector = $("#optionSelector" + optionIndex),
                            optionSelectorType = optionSelector.attr("data-type"),
                            productOptionValues = productOptions[i].values,
                            productOptionName = productOptions[i].name,
                            optionChecked = false,
                            swatchOptions = "";

                        if (optionSelectorType == "radio") {
                            var optionFormElement = optionSelector.find('.form__element');

                            if (productOptionName == "Color" || productOptionName == "Colour" ) {
                                optionChecked = true;
                            }

                            for (let j = 0; j < productOptionValues.length; j++) {
                                var productOptionIndex = j+1;
                                swatchOptions += "<div class='swatch__option' data-swatch='"+productOptionValues[j]+"'>";
                                    if (productOptionName == "Color" || productOptionName == "Colour" ) {
                                        swatchOptions += "<input checked type='radio' data-single-option-selector='' id='"+productOptions[i].name+"-"+productOptionIndex+"' value='"+productOptionValues[j]+"' name='"+productOptions[i].name+"' data-index='option"+optionIndex+"' data-type='radio' class='sr-only'>";
                                    } else {
                                        swatchOptions += "<input  type='radio' data-single-option-selector='' id='"+productOptions[i].name+"-"+productOptionIndex+"' value='"+productOptionValues[j]+"' name='"+productOptions[i].name+"' data-index='option"+optionIndex+"' data-type='radio' class='sr-only'>";
                                    }
                                    swatchOptions += "<label for='"+productOptions[i].name+"-"+productOptionIndex+"' class='form__option-label'><span class='form__option-label-inner'></span><span class='form__option-label-visually-hidden'>"+productOptionValues[j]+"</span></label>";
                                swatchOptions += "</div>";
                            }

                            optionFormElement.html(swatchOptions);

                        } else if (optionSelectorType == "dropdown") {
                            // TODO
                            var optionFormElement = optionSelector.find('.form__element');

                            if (productOptionName == "Color" || productOptionName == "Colour" ) {
                                optionChecked = true;
                            }

                            swatchOptions += "<select id='SingleOptionSelector-"+optionIndex+"' data-single-option-selector='' class='form__control form__select single-option-selector' data-type='dropdown' data-index='option"+optionIndex+"'>";

                            for (let j = 0; j < productOptionValues.length; j++) {
                                var productOptionIndex = j+1;
                                swatchOptions += "<option value='"+productOptionValues[j]+"'>";
                                swatchOptions += productOptionValues[j];
                                swatchOptions += "</option>";
                            }

                            swatchOptions += "</select>";
                            swatchOptions += "<span class='icon select__caret svg--baseline'><svg class='icon icon__arrow--down'><use xlink:href='#icon-arrow--down'></use></svg></span>";

                            optionFormElement.html(swatchOptions);
                        }
                    }

                    $('.product__feature-image .swiper-wrapper').html(productImagesSwiperWrapper);
                    $('.product__thumbnail-wrapper .swiper-wrapper').html(productThumbnailsSwiperWrapper);

                    self.productSingleObject = JSON.parse(
                        $(selectors.productJson, this.$container).html(),
                    );

                    const options = {
                        $container: self.$container,
                        enableHistoryState: self.$container.data('enable-history-state') || false,
                        radioOptionSelector: self.radioOptionSelector,
                        singleOptionSelector: selectors.singleOptionSelector,
                        originalSelectorId: selectors.originalSelectorId,
                        product: self.productSingleObject,
                    };

                    self.settings = {};
                    self.variants = new Variants(options);

                    self.$container.on(
                        `variantChange${self.namespace}`,
                        self.updatePDPInformation.bind(self)
                    );
                    self.$container.on(
                        `variantChange${self.namespace}`,
                        self.updateProductPrices.bind(self),
                    );


                    self.initProductVideo();
                    self.initProductCarousel(true);
                    self.initVariantHoverWatch();
                }
            });

            $(selectors.quantity).on('change', function() {
                 self.$container.trigger({
                     type: 'variantPriceChange',
                     variant: self.variants.currentVariant
                 });
             });

             if (this.$featuredImage.length > 0) {
                 this.$container.on(
                     `variantImageChange${this.namespace}`,
                     this.updateImages.bind(this),
                 );
             }

             this.initProductCarousel();
             this.initProductVideo();
             this.updateImages({
                 variant: this.variants.currentVariant
             });
             this.initVariantTitles();
             this.initVariantHoverWatch();
             this.initColorHoverWatch();
             this.updateVariantAvailability(this.$container[0], this.variants.currentVariant);
             //this.initStickyCart();
         },

        initProductVideo: function() {
            var sectionId = this.id;
            $(selectors.productMediaTypeVideo, this.$container).each(function() {
                var $el = $(this);
                console.log($el);
                ProductVideo.init($el, sectionId);
            });
        },

        initProductCarousel: function(reInit = false) {
            let self = this;

            if (reInit == true) {
                productFeatureSwiper.destroy();
                productThumbnailSwiper.destroy();
            }

             // -------------------------------------
             // Carousel Products
             // -------------------------------------
            productThumbnailSwiper = new Swiper('.'+selectors.productThumbnailsSlider+'', {
                 // Optional parameters
                 modules: [Navigation, Scrollbar, A11y, Keyboard, FreeMode],
                 slidesPerView: 4,
                 spaceBetween: 15,
                 freeMode: true,
                 watchSlidesVisibility: true,
                 watchSlidesProgress: true,
                 observeParents: true,
                 observeSlideChildren: true,
                 resizeObserver: true,
                 navigation: true,

                 keyboard: {
                     enabled: false
                 },
                 a11y: false,
                 breakpoints: {
                     // when window width is >= 680px
                     680: {
                         direction: "vertical",
                         slidesPerView: 5,
                         spaceBetween: 20
                     }
                 },
                 multipleActiveThumbs: false
             });

            productFeatureSwiper = new Swiper('.'+selectors.productFeatureSlider+'', {
                 // Optional parameters
                 modules: [Navigation, Thumbs],
                 spaceBetween: 0,

                 // // Navigation arrows
                 navigation: {
                     nextEl: '.swiper-button-next-product',
                     prevEl: '.swiper-button-prev-product',
                 },
                 thumbs: {
                   swiper: productThumbnailSwiper,
                 },
                 on: {
                     init: function() {
                         toggleInnerFocus(this);
                     }
                 }
            });


              productFeatureSwiper.on('slideChange ', function () {
               // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                 var previousSlideIndex = productFeatureSwiper.previousIndex,
                     currentSlideIndex = productFeatureSwiper.activeIndex;

                 // If current slide has video, trigger "mediaVisible" event to play the video. Then if the previous slide has video, trigger the "mediaHidden" event to pause it.
                 var currentMedia = $('.product__feature-image .swiper-slide[data-index="'+currentSlideIndex+'"] .product-single__media-wrapper'),
                     previousMedia = $('.product__feature-image .swiper-slide[data-index="'+previousSlideIndex+'"] .product-single__media-wrapper');

                 previousMedia.trigger("mediaHidden");
                 currentMedia.trigger("mediaVisible");
                   toggleInnerFocus(this);

             });

             $(productFeatureSwiper.slides).each(function(index, slide) {
                 $(slide).on('keydown', function(e) {
                     if (e.key === "Escape") {
                         $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                             $(thumbnailSlide).attr('tabindex', '0');
                         })

                         productThumbnailSwiper.slides[index].focus();
                     }
                 })
             })



             $(productThumbnailSwiper.slides).each(function(index, slide) {
                 $(slide).on('focus', function(e) {
                     let slideIndex = slide.getAttribute('data-index');
                     self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                     self.slideToSlide(productFeatureSwiper, slideIndex, true);
                     $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                         $(thumbnailSlide).attr('tabindex', '0');
                     })
                 })
                 $(slide).on('keydown', function(e) {
                     if (e.key === "Enter") {
                         $(productThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                             $(thumbnailSlide).attr('tabindex', '-1');
                         })
                         $(slide).attr('tabindex', '0');
                         let slideIndex = parseInt(slide.getAttribute('data-index'));
                         productFeatureSwiper.slides[slideIndex].focus();
                     }
                 })
             });

             $(productThumbnailSwiper.navigation.nextEl).on('click', function(e) {
                 let slideIndex = productThumbnailSwiper.activeIndex;
                 self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                 self.slideToSlide(productFeatureSwiper, slideIndex, true);
             })

             $(productThumbnailSwiper.navigation.prevEl).on('click', function(e) {
                 let slideIndex = productThumbnailSwiper.activeIndex;
                 self.slideToSlide(productThumbnailSwiper, slideIndex, true);
                 self.slideToSlide(productFeatureSwiper, slideIndex, true);
             })



             selectors.productSwiperThumbs = productThumbnailSwiper;
             selectors.productSwiperFeature = productFeatureSwiper;
         },


         initVariantTitles() {
             this.changeVariantTitles(this.variants.currentVariant);
         },
         disableVariants(target, valuesToEnable) {

             // Loop through all the Option Selectors and check which one is a swatch selector
             var optionSelector1 = $(target).find('[data-index="option1"]');
             var optionSelector2 = $(target).find('[data-index="option2"]');
             var optionSelector3 = $(target).find('[data-index="option3"]');
             var is_swatch_selector1 = false;
             var is_swatch_selector2 = false;
             var is_swatch_selector3 = false;

             if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                 is_swatch_selector1 = true;
             }

             if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                 is_swatch_selector2 = true;
             }

             if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                 is_swatch_selector3 = true;
             }

             var option1 = $(target).find('input[data-index="option1"]');
             var option2 = $(target).find('input[data-index="option2"]');
             var option3 = $(target).find('input[data-index="option3"]');

             // If there are 3 option selectors
             if (optionSelector3.length) {

                 // If the third option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 2.
                 if (is_swatch_selector3 == true) {

                     option1.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                     })
                     option2.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                     })

                     option3.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                         if (!valuesToEnable.option3.includes(input.value)) {
                             $(input.nextElementSibling).addClass('swatch--disabled');
                         }
                     })

                 // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1 and 3.
                 } else if (is_swatch_selector2 == true) {

                     option1.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                     });

                     option2.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                         if (!valuesToEnable.option2.includes(input.value)) {
                             $(input.nextElementSibling).addClass('swatch--disabled');
                         }
                     });

                 // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2 and 3.
                 } else if (is_swatch_selector1 == true) {

                     option1.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                         if (!valuesToEnable.option1.includes(input.value)) {
                             $(input.nextElementSibling).addClass('swatch--disabled');
                         }
                     })
                 }

             // If there are 2 option selectors
             } else if (optionSelector2.length) {

                 // If the second option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 1.
                 if (is_swatch_selector2 == true) {

                     option1.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                     });

                     option2.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                         if (!valuesToEnable.option2.includes(input.value)) {
                             $(input.nextElementSibling).addClass('swatch--disabled');
                         }
                     });

                 // If the first option selector is a swatch selector, the available/unavailable state only shows up on this selector based on selected options from Selector 2.
                 } else if (is_swatch_selector1 == true) {

                     option1.each(function() {
                         var input = $(this)[0];
                         $(input.nextElementSibling).removeClass('swatch--disabled');
                         if (!valuesToEnable.option1.includes(input.value)) {
                             $(input.nextElementSibling).addClass('swatch--disabled');
                         }
                     })
                 }
             }
         },
         updateVariantAvailability(target, variant) {

            // Loop through all the Option Selectors and check which one is a swatch selector
            var optionSelector1 = $(target).find('[data-index="option1"]');
            var optionSelector2 = $(target).find('[data-index="option2"]');
            var optionSelector3 = $(target).find('[data-index="option3"]');
            var is_swatch_selector1 = false;
            var is_swatch_selector2 = false;
            var is_swatch_selector3 = false;

            if (optionSelector1.length && optionSelector1.attr('type') == 'radio') {
                is_swatch_selector1 = true;
            }

            if (optionSelector2.length && optionSelector2.attr('type') == 'radio') {
                is_swatch_selector2 = true;
            }

            if (optionSelector3.length && optionSelector3.attr('type') == 'radio') {
                is_swatch_selector3 = true;
            }

            var availableValues = {
                option1: [],
                option2: [],
                option3: []
            }

            var variants = this.variants.product.variants;
            var currentSelectedOptions = this.variants._getCurrentOptions();


            // Combine all available variants
            var availableVariants = variants.filter(function(el) {
                if (!el.available) {
                    return false;
                }

                // If there are 3 option selectors
                if (optionSelector3.length) {

                    if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                        (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {
                        $(selectors.addToCart).removeClass('btn--select-size');

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value,
                            option2: currentSelectedOptions[1].value,
                            option3: currentSelectedOptions[2].value
                        };

                        // If the third option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 2.
                        if (is_swatch_selector3 == true) {

                            // Option 3 based on selected Option 1 and 2
                            if ((currentVariant.option1 === el.option1 || !el.option1) &&
                                (currentVariant.option2 === el.option2 || !el.option2)) {
                                return true;
                            }

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1 and 3.
                        } else if (is_swatch_selector2 == true) {

                            if ((currentVariant.option1 === el.option1 || !el.option1) && (currentVariant.option3 === el.option3 || !el.option3)) {
                                return true;
                            }

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2 and 3.
                        } else if (is_swatch_selector1 == true) {

                            if ((currentVariant.option2 === el.option2 || !el.option2) && (currentVariant.option3 === el.option3 || !el.option3)) {
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }
                // If there are only 2 option selectors
                } else if (optionSelector2.length) {

                    if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                        (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown")) {
                        $(selectors.addToCart).removeClass('btn--select-size');

                        var currentVariant = {
                            option1: currentSelectedOptions[0].value,
                            option2: currentSelectedOptions[1].value
                        };

                        // If the second option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 1.
                        if (is_swatch_selector2 == true) {

                            if (currentVariant.option1 === el.option1 || !el.option1) {
                                return true;
                            }

                        // If the first option selector is a swatch selector, get available variants for all options of this selector based on selected options from Selector 2.
                        } else if (is_swatch_selector1 == true) {
                            $(selectors.addToCart).removeClass('btn--select-size');

                            if (currentVariant.option2 === el.option2 || !el.option2) {
                                return true;
                            }
                        }
                    } else {
                        return true;
                    }
                } else if (optionSelector1.length) {
                    if (optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") {
                        $(selectors.addToCart).removeClass('btn--select-size');
                    }
                }

            });

            availableVariants = Object.assign({}, availableVariants);

            for (var property in availableVariants) {
                 if (availableVariants.hasOwnProperty(property)) {
                   var item = availableVariants[property],
                       option1 = item.option1,
                       option2 = item.option2,
                       option3 = item.option3;

                   if (option1) {
                     if (availableValues.option1.indexOf(option1) === -1) {
                         availableValues.option1.push(option1);
                     }
                   }
                   if (option2) {
                     if (availableValues.option2.indexOf(option2) === -1) {
                       availableValues.option2.push(option2);
                     }
                   }
                   if (option3) {
                     if (availableValues.option3.indexOf(option3) === -1) {
                       availableValues.option3.push(option3);
                     }
                   }
                 }
            }


            this.disableVariants(target, availableValues);
         },


         slideToSlide(slider, slideIndex, transition) {
             if (transition) {
                 slider.slideTo(slideIndex);
             } else {
                 slider.slideTo(slideIndex, 0);
             }
         },

         // triggering change image when using with Slider
         swapImage(imageId) {

             let newImageId = imageId;

             // If "imageId" is not defined in the function parameter, find it by the current product image
             if (typeof newImageId === 'undefined') {
                 newImageId = $(
                     `${selectors.productImageWrapper}:not('.${cssClasses.hide}')`,
                 ).data('image-id');
             }

             const $thumbnail = $(
                 `${selectors.productThumbs}[data-thumbnail-id='${newImageId}']`,
             );



             var slideIndex = parseInt($thumbnail.parents('.swiper-slide').attr('data-index'));

             // Swipe JS
             this.slideToSlide(selectors.productSwiperThumbs, slideIndex, false);
             this.slideToSlide(selectors.productSwiperFeature, slideIndex, false);

         },

         /**
          * Updates the DOM state of the add to cart button
          *
          * @param {boolean} enabled - Decides whether cart is enabled or disabled
          * @param {string} text - Updates the text notification content of the cart
          */
        updateAddToCartState(evt) {
            const variant = evt.variant;
            this.updateVariantAvailability(evt.target, variant);
            let $this = this;

            let optionSelector1 = $(evt.target).find('[data-index="option1"]'),
                optionSelector2 = $(evt.target).find('[data-index="option2"]'),
                optionSelector3 = $(evt.target).find('[data-index="option3"]'),
                flag = false;
            if (optionSelector3.length) {
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown") &&
                    (optionSelector3.is(':checked') || optionSelector3.attr('data-type') == "dropdown")) {
                    flag = true;
                }
            } else if (optionSelector2.length) {
                if ((optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") &&
                    (optionSelector2.is(':checked') || optionSelector2.attr('data-type') == "dropdown")) {
                    flag = true;
                }
            } else if (optionSelector1.length) {
                if (optionSelector1.is(':checked') || optionSelector1.attr('data-type') == "dropdown") {
                    flag = true;
                }
            }

            if (flag == true) {

                $(selectors.originalSelectorId).find('option').each(function(){
                    if ($(this).val() == variant.id) {
                        // const inventory_quantity = parseInt($(this).attr('data-inventory-quantity'));
                        // $('.stock-left__count').text(inventory_quantity);
                        // if(0 < inventory_quantity && inventory_quantity < 5) {
                        //     $('.stock-left__container').addClass('js__isShown');
                        // } else {
                        //     $('.stock-left__container').removeClass('js__isShown');
                        // }
                        // return false;
                    }
                })

                if (variant) {
                    $(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
                    const productVariantURL = "/products/"+ $(selectors.originalSelectorId).attr('data-product-handle') +"?variant=" + variant.id;
                    window.history.replaceState("","", productVariantURL);
                } else {
                    $(selectors.addToCart, this.$container).prop('disabled', true);

                    $(selectors.addToCartText, this.$container).html(
                        theme.strings.unavailable,
                    );

                    $(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);
                    return;
                }

                if (variant.available) {

                    $(selectors.addToCart, this.$container).prop('disabled', false);
                    $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                } else {

                    $(selectors.addToCart, this.$container).prop('disabled', true);
                    $(selectors.addToCartText, this.$container).html(
                        theme.strings.soldOut,
                    );
                }
            }
        },

        changeColorTitles(evt) {
            $('.color-swatches__container .swatch__option.selected').each(function() {
                var container = $(this).parents('.color-swatches');
                var subtitle = container.find('.color__container .color__name');
                var colorLabel = container.find('.color__container .color__label');
                subtitle.text($(this).attr('data-swatch'));
                if ($(this).attr('data-color-label')) {
                    colorLabel.find('.color__label-wrapper').text($(this).attr('data-color-label'));
                    colorLabel.addClass('js__isShown');
                } else {
                    colorLabel.find('.color__label-wrapper').text("");
                    colorLabel.removeClass('js__isShown');
                }
            })
          },

        tempChangeColorTitle(evt) {
            var target = evt.currentTarget;
            var newLabel = target.innerText;
            var container = $(target).parents('.color-swatches');
            var subtitle = container.find('.color__container .color__name');
            var colorLabel = container.find('.color__container .color__label');
            subtitle.text(newLabel);
            if ($(target).attr('data-color-label')) {
                colorLabel.find('.color__label-wrapper').text($(target).attr('data-color-label'));
                colorLabel.addClass('js__isShown');
            } else {
                colorLabel.find('.color__label-wrapper').text("");
                colorLabel.removeClass('js__isShown');
            }
        },

        changeVariantTitles(evt) {
           $('.swatch__option input[data-single-option-selector]:checked').each(function() {
             var container = $(this).parents('.selector-wrapper');
             var subtitle = container.find('.swatch__title .swatch__subtitle');
             subtitle.text($(this).val());
           })
        },

         tempChangeVariantTitle(evt) {
           var target = evt.currentTarget;
           var newLabel = target.innerText;
           var container = $(target).parents('.selector-wrapper');
           var subtitle = container.find('.swatch__title .swatch__subtitle');
           subtitle.text(newLabel);
         },

         initVariantHoverWatch() {
            var changeVariantTitles = this.changeVariantTitles;
            var tempChangeVariantTitle = this.tempChangeVariantTitle;
            $('.swatch__option input[data-single-option-selector] + label.form__option-label').each(function() {
                $(this).on('mouseenter', tempChangeVariantTitle).on('mouseleave', changeVariantTitles);
            });
         },

         initColorHoverWatch() {
            var changeColorTitles = this.changeColorTitles;
            var tempChangeColorTitle = this.tempChangeColorTitle;
            $('.color-swatches__container .swatch__option').each(function() {
              $(this).on('mouseenter', tempChangeColorTitle).on('mouseleave', changeColorTitles);
            });
          },

         updatePDPInformation(evt) {
           this.updateAddToCartState(evt);
           this.changeVariantTitles(evt);
           this.changeVariantSku(evt);
         },

         updateImages(evt) {
             const variant = evt.variant;

             if (typeof variant.featured_media != 'undefined') {

                 const imageId = this.id + "-" + variant.featured_media.id;

                 this.swapImage(imageId);
             }
         },
         changeVariantSku(evt) {
             const variant = evt.variant;
             const $sku = $(selectors.productSku, this.$container);

             $sku.html(variant.sku);
         },

         /**
          * Updates the DOM with specified prices
          *
          * @param {string} productPrice - The current price of the product
          * @param {string} comparePrice - The original price of the product
          */
         updateProductPrices(evt) {
             console.log("change");
             const variant = evt.variant;
             const $comparePrice = $(selectors.comparePrice, this.$container);
             const $compareEls = $comparePrice.add(
                 selectors.comparePriceText,
                 this.$container,
             );
             const quantity = parseInt($(selectors.quantity).val());

             $(selectors.productPrice, this.$container).html(
                 formatMoney(variant.price, theme.moneyFormat),
             );

             const priceWithQuantity = variant.price * quantity;
             $('#addToCartPricing').html(
                 formatMoney(priceWithQuantity, theme.moneyFormat),
             );

             if (variant.compare_at_price > variant.price) {
                 $comparePrice.html(
                     formatMoney(variant.compare_at_price, theme.moneyFormat),
                 );
                 $compareEls.removeClass(cssClasses.hide);
                 $(selectors.productPrice, this.$container).addClass('price__original--sale');

                 $('.product__tag--inline').removeClass('product__tag--inline--hidden');
             } else {
                 $comparePrice.html('');
                 $compareEls.addClass(cssClasses.hide);
                 $(selectors.productPrice, this.$container).removeClass('price__original--sale');
                 $('.product__tag--inline').addClass('product__tag--inline--hidden');
             }
         },

         initStickyCart() {
           let options = {
             rootMargin: '100px 0px 0px 0px',
             threshold: [0,0.01,1]
           }

           let target = document.querySelector('#productStickyContainer');

           let observer = new IntersectionObserver(this.showHideStickyCart, options);

           observer.observe(target);

           // Mobile cart button
           $('#addToCartSticky').on('click', function() {
             target.scrollIntoView({ behavior: 'smooth' });
           })

         },

         showHideStickyCart(entries, observer) {
             let entry = entries[0];
             if (entry.intersectionRatio >= 1) {
                 entry.target.classList.remove('product__sticky--show');
             } else if (entry.intersectionRatio <= 0 && entry.boundingClientRect.y <= 0) {
                 entry.target.classList.add('product__sticky--show');
                 entry.target.classList.remove('product__sticky--hide');
             } else {
                 entry.target.classList.add('product__sticky--hide');
             }
         },


         /**
          * Event callback for Theme Editor `section:unload` event
          */
         onUnload() {
             this.$container.off(this.namespace);
         },
     });

     load('product-group');
 })
